import React from 'react';
import PropTypes from 'prop-types';
import enhance from './enhance';
import styles from '../styles.module.scss';

export const BodyStyleRow = ({ bodyStylePipeline }) => (
  <div key={bodyStylePipeline.name}>
    <div className={styles.subHeading}>{bodyStylePipeline.name}</div>
    <div className={styles.count}>
      <span className={styles.column}>{bodyStylePipeline.dealerInventory}</span>
      <span className={styles.column}>
        {bodyStylePipeline.processingCenter}
      </span>
      <span className={styles.column}>{bodyStylePipeline.inTransitToVPS}</span>
      <span className={styles.column}>
        {bodyStylePipeline.scheduledInProduction}
      </span>
      <span className={styles.column}>
        {bodyStylePipeline.producedNotShipped}
      </span>
      <span className={styles.column}>{bodyStylePipeline.onOrder}</span>
      <span className={styles.column}>{bodyStylePipeline.unsubmitted}</span>
      <span className={styles.column}>
        {bodyStylePipeline.projectedPipeline}
      </span>
    </div>
  </div>
);
BodyStyleRow.propTypes = {
  bodyStylePipeline: PropTypes.object.isRequired,
};
export default enhance(BodyStyleRow);
